module.exports = __webpack_public_path__ + "img/espn_extra.5ccbb30f.png";